import { PropsWithChildren } from "react";

import { css } from "@compiled/react";

import { AtlassianLogo, ConfluenceLogo } from "@atlaskit/logo";
import { token } from "@atlaskit/tokens";
import { AccountSetupOverlay } from "@atlassian/confluence-account-setup";

export const CFind3467SignupBackgroundLayout = ({
    children
}: PropsWithChildren) => {
    return (
        <AccountSetupOverlay>
            <div css={containerStyles} data-testid="cfind-3467-signup-form">
                <div css={formWrapperCss}>
                    <div css={productLogoContainerCss}>
                        <ConfluenceLogo size="small" appearance="brand" />
                    </div>
                    {children}
                </div>
                <div css={atlassianLogoContainerCss}>
                    <AtlassianLogo
                        appearance="inverse"
                        size="small"
                        testId="atlassian-logo"
                        label="Atlassian logo"
                    />
                </div>
            </div>
        </AccountSetupOverlay>
    );
};

const containerStyles = css({
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: "100vh"
});

const formWrapperCss = css({
    backgroundColor: token("elevation.surface"),
    borderRadius: "8px",
    boxShadow: token("elevation.shadow.overlay"),
    boxSizing: "content-box",
    margin: "0 auto",
    maxWidth: "calc(100vw - 2rem)",
    width: 400,
    padding: "40px 80px",
    minHeight: 520
});

const productLogoContainerCss = css({
    display: "flex",
    justifyContent: "center",
    marginBlockStart: "8px",
    marginBlockEnd: "16px"
});

const atlassianLogoContainerCss = css({
    position: "absolute",
    insetBlockEnd: "100px"
});
